export var filterArrayAdd = function filterArrayAdd(array, object, key) {
  var func = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "push";
  var index = array.findIndex(function (o) {
    return o[key] === object[key];
  });
  if (index === -1) array[func](object);else {
    array.splice(index, 1);
    array[func](object);
  }
  return array;
};
export var filterArrayRemove = function filterArrayRemove(array, object, key) {
  var index = array.findIndex(function (o) {
    return o[key] === object[key];
  });
  if (index === -1) array.push(object);else {
    array.splice(index, 1);
  }
  return array;
};